import { HAS_WINDOW } from '@eventbrite/feature-detection';
import { useState } from 'react';
import { categoryToIconMap, ICategoryToIconMap } from '../categoryToIconMap';

export const useGetSelectedCategory = () => {
    let initialCategory;

    if (HAS_WINDOW) {
        const searchParams = new URLSearchParams(window.location.search);
        const currentParam = decodeURIComponent(
            searchParams.get('category') ?? '',
        );

        initialCategory =
            categoryToIconMap.find(
                (category) =>
                    category.searchParam === currentParam.toLowerCase(),
            ) ?? categoryToIconMap[0];
    }

    const [categoryTag, setCategoryTag] = useState<ICategoryToIconMap>(
        initialCategory as ICategoryToIconMap,
    );

    return { categoryTag, setCategoryTag };
};
